module.exports = function (AlgorithmIdentifier, PrivateKey) {
  return function () {
    this.seq().obj(this.key('version').int(), this.key('algorithm').use(AlgorithmIdentifier), this.key('privateKey').use(PrivateKey));
  };
};